import { render, staticRenderFns } from "./TrainSideBar.vue?vue&type=template&id=954a9cb6&scoped=true"
import script from "./TrainSideBar.vue?vue&type=script&lang=js"
export * from "./TrainSideBar.vue?vue&type=script&lang=js"
import style0 from "./TrainSideBar.vue?vue&type=style&index=0&id=954a9cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954a9cb6",
  null
  
)

export default component.exports